/**
 * A model layer for making permissions play like participants in 8.12
 * @class
 */
import Base from './participant';

export default class PermissionParticipant extends Base {
	/** @override */
	constructor(attrs, opts) {
		// This model does not have calls to the server
		opts.rpc = false;
		super(attrs, opts);
	}

	/**
	 * We do not save to the serve rourselves
	 * @override
	 */
	destroy() {
		// Just remove and let the underlying permissions handle the saving
		this.collection.remove(this.id);
		return new $.Deferred().resolveWith(this);
	}

	/**
	 * We do not save to the serve rourselves
	 * @override
	 * @param {object} data Data
	 * @param {object} opts Options
	 */
	parseAndSave(data, opts) {
		// Just set and let the underlying permissions handle the saving
		this.set(data, opts);

		return new $.Deferred().resolveWith(this);
	}

	/** @type {string} */
	static get __name__() {
		return 'PermissionParticipant';
	}
}
